
export const NotificationInAppStatus = {
    PREPARED : 1,
    RECEIVED : 2,
    IMPRESSION : 3,
    OPENED : 4,
}

export const StatusNotiInAppTagAction = {
    DISPLAYED : '2',
    READ_OR_UNREAD :'3',
}

export const UserStoreInfoTagAction = {
    LOGIN : 1,
    LOGOUT : 2,
    RENEWTOKEN : 3,
}


export const TypeNotifications = {
  PUSH: 1,
  IN_APP: 2,
  PUSH_VITA_STICKY:3,
  PUSH_VITA_NON_STICKY: 4,
}
  
